import type { NewProduct, Product } from 'pages/Admin/Products/types';
import type { BasicSuccessResponse, HTTPFunctions } from './types';
import type { Billing } from 'pages/Payments/BillingOwner/types';
import type { NewPlan, Plan } from 'pages/Admin/Plans/types';
import type { PaymentsSummary } from 'pages/Payments/types';
import type { Subscription } from 'pages/Payments/PricingPrice/types';
import type { Invoice } from 'pages/Payments/Invoices/types';

const payments = ({ get, post, put, del }: HTTPFunctions) => ({
  listProducts: () => get<Product[]>('/products/'),
  getProductById: (id: string) => get<Product>(`/products/${id}`),
  addProduct: (data: NewProduct) => post<Product>('/products/', data),
  updateProduct: (data: Product) => put<Product>(`/products/${data.id}`, data),
  delProductById: (id: number) => del<BasicSuccessResponse>(`/products/${id}`),
  listPlans: () => get<Plan[]>('/plans/'),
  getPlanById: (id: string) => get<BasicSuccessResponse>(`/plans/${id}`),
  addPlan: (data: NewPlan) => post<Plan>('/plans/', data),
  updatePlan: (data: Plan) => put<Plan>(`/plans/${data.id}`, data),
  delPlanById: (id: number) => del<BasicSuccessResponse>(`/plans/${id}`),
  getPaymentsSummary: () => get<PaymentsSummary>('/summary/'),
  createCheckoutSession: () => post<string>('/create-checkout-session', {}),
  createInfoCheckoutSession: () => post<string>('/info/create-checkout-session', {}),
  reactivateSubscription: () => put<BasicSuccessResponse>('/subscriptions/reactivate', {}),
  getSubscription: () => get<Subscription>('/subscriptions/'),
  cancelSubscription: () => del<Subscription>('/subscriptions/'),
  getCurrentCredits: () => get<number>('/subscriptions/credits'),
  getBilling: () => get<Billing>('/billing/'),
  addBilling: (data: Billing) => post<BasicSuccessResponse>('/billing/', data),
  updateBilling: (data: Billing) => put<BasicSuccessResponse>('/billing/', data),
  getInvoices: () => get<Invoice[]>('/invoices/'),
  getInvoicesLastest: () => get<{invoice: string}>('/invoices/lastest'),
});

export default payments;
